import { element } from 'protractor';
import { Component, OnDestroy, OnInit, Input, OnChanges, SimpleChanges, ElementRef, ViewChild, Renderer2, ChangeDetectorRef, HostListener } from '@angular/core';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { Source } from '../../../models/source';
import { DocumentData } from '../../../services/document-data.service';
import { Subscription, of, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import Mark from 'mark.js';
// import {HighlightActions} from '../../shared/highlight_actions/highlight_actions.component';
// import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import { ReportService } from "../../../services/report.service";
import { NgxSpinnerService } from 'ngx-spinner';
import { ReportComponent } from '../../../report.component';
import { Router } from '@angular/router';
import { StylometricStateService } from '../../../services/stylometric-state.service';
// import {SpinnerService} from "../../../services/spinner.service";
// import { ManipulationActions } from '../../shared/manipulation_actions/manipulation_actions.component';


@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss'],
  // providers: [DialogService]
})
export class DocumentComponent implements OnInit, OnDestroy, OnChanges {
  title = 'document'
  @Input() pdfSrc = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf'
  tempPdfSrc: any;
  @Input() summaryDetails: any;
  @Input() pdfImagesSrc: any;
  @Input() allSources: {
    sources?: [] | undefined,
    excludedSources?: [] | undefined
  } = {
      sources: [],
      excludedSources: [],
    }
  selectedSources: number[] = []
  @Input() sentencesWithAI!: [];
  @Input() isOriginalLanguage: any;
  selectedPage: number = 1;
  page = 1;
  loadedPagesId: any[] = [];
  loadedPages: any[] = [];
  pagesToDraw: any[] = [];
  pagesToDestroy: any[] = [];
  numberOfDifference = 2;
  oldPage = 1;
  notFound: any
  displayAiText = false;
  displayManipulations = false;
  sources: any;
  activePlagSources: any;
  pdfLoadedPages = [];
  documentPages: any;
  totalPages!: number;
  currentPageSubscription: Subscription[] = []
  markInstance: any
  crossPlagIndex: any
  sourceId: any;
  sentenceId: any;
  showStylometrics = false;
  // ref: DynamicDialogRef | undefined;
  highlightQuotes = true
  analysisType: string = 'none';
  totalSentencesWithAI!: number;
  @Input() selectedManipulation: any;
  @Input() isOnManipulation: any;
  @Input() sentenceDetails: any;
  @Input() allManipulations: any;
  @Input() submissionId: any;
  @Input() context_similarity: any;
  @Input() submission: any;
  @Input() exactMatchThreshold: number;
  @Input() contextSimilarityThreshold: number;
  currentlyHighlightedElement = [];
  zoom = 1;
  selectedTransltaionCode
  twoColumns = false;
  isProjectSynapseActive = false;
  secondPdfSrc: string = '';
  @Input() projectSynapseData: any;
  projectSynapseComparison: any;
  // Make  it a  html collection

  @ViewChild('connectionLines', { static: true }) connectionLines!: ElementRef<SVGElement>;
  @ViewChild('viewer', { static: true }) viewer!: any;
  @ViewChild('viewerSecond') viewerSecond: any;

  // Add these properties after the existing properties
  private readonly LIGHT_PURPLE = 'rgba(163, 137, 228, 0.45)';
  private readonly DARK_PURPLE = 'rgba(123, 97, 188, 0.65)';
  private readonly EXCLUDED_GREY = 'rgba(128, 128, 128, 0.45)';
  private readonly EXCLUDED_DARK_GREY = 'rgba(128, 128, 128, 0.65)';
  private activeSection: string | null = null;
  private readonly PROJECT_SYNAPSE_SIMILARITY_THRESHOLD = 50;

  @Input() sideBarCollapsed: boolean = false;

  // Add this property to track which sections have been numbered
  private numberedSections = new Set<string>();

  // Add this property to the class
  private sortedSynapseEntries: [string, any][] = [];

  // Add this property to track scroll synchronization state
  private isScrollingSynced = false;

  // Add this property to store the active section before switching to side-by-side view
  private lastActiveSection: string | null = null;

  // Add this property to track attempts for applyActiveSection method
  private _applyActiveSectionAttempts = 0;

  // Add this property to store the section to scroll to after a page change
  private _pendingSectionScroll: string | null = null;

  private highlightSubject = new Subject<void>();
  private destroy$ = new Subject<void>();
  private lastChangeTime = 0;
  private readonly DEBOUNCE_TIME = 300; // 300ms debounce

  private subscriptions: Subscription[] = [];

  constructor(
    public documentDataService: DocumentData,
    //  private dialogService: DialogService,
    private reportService: ReportService,
    private spinnerService: NgxSpinnerService,
    private reportComponent: ReportComponent,
    private renderer: Renderer2,
    private router: Router,
    private stylometricState: StylometricStateService,
    private cdr: ChangeDetectorRef
  ) {
    this.currentPageSubscription.push(this.documentDataService.getCurrentPage().subscribe(page => {
      this.scrollPage(page);
      // this.page = page;
    }))
  }

  ngOnInit(): void {
    // Store all subscriptions for proper cleanup
    this.subscriptions = [];

    this.subscriptions.push(
      this.stylometricState.isProjectSynapseActive$.subscribe(isActive => {
        const wasInTwoColumnMode = this.twoColumns;
        this.isProjectSynapseActive = isActive;

        if (!isActive && wasInTwoColumnMode) {
          // Forcefully reset PDF viewer state
          this.secondPdfSrc = '';
          this.twoColumns = false;

          // Reset any two-column specific styles
          this.removeHighlight();

          // Force immediate UI update
          this.cdr.detectChanges();

          // Reset viewer sizes with zero timeout to ensure it runs after change detection
          setTimeout(() => {
            this.resetViewerSizes();
            this.updateViewerSize();

            // Force browser to recalculate layout
            window.dispatchEvent(new Event('resize'));
          }, 0);
        }

        // Rest of the existing code...
      })
    );

    this.subscriptions.push(
      this.stylometricState.selectedAIModel$.subscribe(model => {
        if (model) {
          // Store the previous comparison data for reference
          const previousComparison = this.projectSynapseComparison;

          // Update with the new model data
          this.projectSynapseComparison = model.comparisonData.comparison;

          // Only reload highlights if:
          // 1. We have a valid comparison object
          // 2. We're in Project Synapse mode
          // 3. Either there was a change in comparison data or we didn't have data before
          // 4. The change didn't come from sentence-information component
          if (this.projectSynapseComparison &&
            this.isProjectSynapseActive &&
            (previousComparison !== this.projectSynapseComparison) &&
            !model.skipHighlightUpdate) {

            // Clear existing highlights
            this.removeHighlight();

            // Re-apply highlights with the new model data
            setTimeout(() => {
              this.doAIHighlight(this.page);
              // Force change detection to update the view
              this.cdr.detectChanges();
            }, 50);
          }
        }
      })
    );

    this.subscriptions.push(
      this.stylometricState.selectedModelPdfUrl$.subscribe(url => {
        if (url) {
          this.secondPdfSrc = url;
          // Force change detection
          this.cdr.detectChanges();
        }
      })
    );
    this.setupHighlightDebounce();

    this.subscriptions.push(
      this.reportService.selectedTransltaionCodeObject.subscribe(data => {
        if (data !== null && data.length !== 0) {
          this.selectedTransltaionCode = data
        }
      })
    );

    this.spinnerService.show()
    this.documentDataService.totalPagesSubject.next(this.totalPages)
    this.subscriptions.push(
      this.reportService.toggleQuotesObject.subscribe(data => {
        this.highlightQuotes = data
        this.removeHighlight()
        this.callHighlight(this.page)
      })
    );

    this.subscriptions.push(
      this.reportService.selectedSourcesObject.subscribe(data => {
        this.selectedSources = data
        this.removeHighlight()
        this.callHighlight(this.page)
      })
    );

    this.subscriptions.push(
      this.reportService.selectAnalysisTypeObject.subscribe(data => {
        // Clear all highlights immediately when switching analysis types
        this.removeHighlight();

        // Store previous analysis type to handle transitions
        const previousAnalysisType = this.analysisType;
        this.analysisType = data;

        // Store current Project Synapse state to preserve it during transitions
        const wasInProjectSynapse = this.isProjectSynapseActive;

        // Add a small delay to ensure the DOM is ready
        setTimeout(() => {
          // Handle the new analysis type
          if (this.analysisType === 'ai') {
            this.displayAiText = true;
            this.displayManipulations = false;

            // Only disable Project Synapse when explicitly switching away from it,
            // not when just changing analysis types
            if (previousAnalysisType === 'projectSynapse' && !wasInProjectSynapse) {
              this.isProjectSynapseActive = false;
              console.log('Calling toggleProjectSynapseActive 21');
              this.stylometricState.toggleProjectSynapseActive(false);
              this.secondPdfSrc = '';
              this.twoColumns = false;
            }
          } else if (this.analysisType === 'metadata') {
            this.displayAiText = false;
            this.displayManipulations = false;

            // Preserve Project Synapse state when changing to metadata
            // Don't disable Project Synapse just because we're changing analysis type
          } else if (this.analysisType === 'stylometrics') {
            this.displayAiText = false;
            this.displayManipulations = false;
            this.removeHighlight();

            // Preserve Project Synapse state when changing to stylometrics
            // Don't disable Project Synapse just because we're changing analysis type
          } else if (this.analysisType === 'manipulation') {
            this.displayAiText = false;
            this.displayManipulations = true;

            // Ensure Project Synapse is fully disabled when switching to manipulations
            if (wasInProjectSynapse || this.isProjectSynapseActive) {
              this.isProjectSynapseActive = false;
              this.stylometricState.toggleProjectSynapseActive(false);
              this.secondPdfSrc = '';
              this.twoColumns = false;

              // Force a complete highlight removal to clear any Project Synapse highlights
              this.removeHighlight();
            }

            // Now handle manipulations after ensuring Project Synapse is disabled
            this.handleManipulations();
          } else if (this.analysisType === 'none') {
            this.displayAiText = false;
            this.displayManipulations = false;

            // Only disable Project Synapse if we're explicitly leaving that mode
            // via a user action, not just because we're changing analysis type
          } else {
            this.displayAiText = false;
            this.removeHighlight();
          }

          // After state changes, reapply appropriate highlights
          if (this.isProjectSynapseActive) {
            this.doAIHighlight(this.page);
          } else {
            this.callHighlight(this.page);
          }
        }, 100);
      })
    );
    // Set initial viewer size
    setTimeout(() => {
      this.updateViewerSize();
    }, 100);

    this.subscriptions.push(
      this.reportService.isSideBySideVisibleSubject.subscribe(isVisible => {
        this.handleSideBySideVisibilityChange(isVisible);
      })
    );

    // Call the viewer parameter setup after initialization
    setTimeout(() => {
      this.setViewerParameters();
    }, 200);

    this.subscriptions.push(
      this.reportService.projectSynapseComparison$.subscribe(data => {
        if (data && data.comparison && this.isProjectSynapseActive) {
          console.log('Received Project Synapse comparison update:', data.timestamp);

          // Update the local comparison data
          this.projectSynapseComparison = data.comparison;

          // Clear existing highlights and re-apply with new data
          this.removeHighlight();

          // Use setTimeout to ensure DOM has updated before re-highlighting
          setTimeout(() => {
            this.doAIHighlight(this.page);
            // Force change detection to update the view
            this.cdr.detectChanges();
          }, 50);
        }
      })
    );

    // Subscribe to section update events
    this.currentPageSubscription.push(
      this.reportService.sectionUpdate$.subscribe(update => {
        if (update && update.type === 'sectionExclusionToggled') {
          // Update the highlighting for this section
          if (this.projectSynapseComparison && update.sectionKey) {
            // Update the section data in our local copy
            if (this.projectSynapseComparison[update.sectionKey]) {
              this.projectSynapseComparison[update.sectionKey].isExcluded = update.isExcluded;

              // If keepActive flag is true, ensure this section is marked as active before updating styles
              if (update.keepActive) {
                this.activeSection = update.sectionKey;
              }

              // Apply highlighting updates to this section only
              this.updateSectionHighlightStyles(update.sectionKey);

              // If keepActive is true, ensure the section number styling is also updated to active state
              if (update.keepActive) {
                this.updateSectionNumberStyle(update.sectionKey, true);
              }
            }
          }
        }
      })
    );
  }

  private setupHighlightDebounce(): void {
    this.highlightSubject.pipe(
      debounceTime(this.DEBOUNCE_TIME),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.removeHighlight();
      if (this.analysisType === 'manipulation') {
        this.handleManipulations();
      } else {
        this.callHighlight(this.page);
      }
    });
  }

  ngAfterViewInit() {
    // Wait for view to be fully initialized
    setTimeout(() => {
      if (this.viewer?.nativeElement) {
        const pdfContainer = this.viewer.nativeElement.querySelector('.ng2-pdf-viewer-container');
        if (pdfContainer) {
          this.renderer.setAttribute(pdfContainer, 'tabindex', '0');
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    let shouldHighlight = false;
    let shouldHandleManipulations = false;

    // Handle PDF source changes
    if (changes['pdfSrc']?.currentValue !== changes['pdfSrc']?.previousValue) {
      this.pdfSrc = changes['pdfSrc'].currentValue;
      this.tempPdfSrc = changes['pdfSrc'].currentValue;
    }

    // Handle image detection URL changes
    if (changes['imageDetectionURL']?.currentValue !== changes['imageDetectionURL']?.previousValue) {
      this.pdfImagesSrc = changes['imageDetectionURL'].currentValue;
    }

    // Handle sources changes
    if (changes['allSources']?.currentValue !== changes['allSources']?.previousValue) {
      this.activePlagSources = this.allSources.sources;
      shouldHighlight = true;
    }

    // Handle manipulation changes
    if (changes['selectedManipulation']?.currentValue !== changes['selectedManipulation']?.previousValue) {
      if (this.analysisType === 'manipulation') {
        shouldHandleManipulations = true;
      }
    }

    // Handle manipulation mode changes
    if (changes['isOnManipulation']?.currentValue !== changes['isOnManipulation']?.previousValue) {
      if (!this.isOnManipulation) {
        this.pdfSrc = this.tempPdfSrc;
      }
      shouldHighlight = true;
    }

    // Handle summary details changes
    if (changes['summaryDetails']?.currentValue !== changes['summaryDetails']?.previousValue) {
      shouldHighlight = true;
    }

    // Batch the highlight operations
    if (shouldHighlight || shouldHandleManipulations) {
      // Use requestAnimationFrame to batch visual updates
      requestAnimationFrame(() => {
        this.removeHighlight();

        if (shouldHandleManipulations) {
          this.handleManipulations();
        } else if (shouldHighlight) {
          this.callHighlight(this.page);
        }
      });
    }

    // Add check for projectSynapseComparison changes
    if (changes && changes['projectSynapseData'] && changes['projectSynapseData'].currentValue !== changes['projectSynapseData'].previousValue) {
      if (this.isProjectSynapseActive) {
        // Get the currently selected model from the state service
        const currentModel = this.stylometricState.getCurrentAIModel();

        // Check if we need to update the comparison data based on the new model
        if (currentModel && currentModel.comparisonData && currentModel.comparisonData.comparison) {
          // Update the comparison data
          this.projectSynapseComparison = currentModel.comparisonData.comparison;

          // Clear and reapply highlights with new data
          this.removeHighlight();

          // Use setTimeout to ensure DOM has updated before re-highlighting
          setTimeout(() => {
            this.doAIHighlight(this.page);
            // Force change detection
            this.cdr.detectChanges();
          }, 50);
        } else {
          // If no model is selected, just refresh the highlights with existing data
          this.removeHighlight();
          this.doAIHighlight(this.page);
        }
      }
    }

    if (changes['sideBarCollapsed']) {
      // Store current analysis type before sidebar toggle
      const currentAnalysisType = this.reportService.selectAnalysisTypeSubject.getValue();

      // Force resize when sidebar state changes
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
        this.updateViewerSize();

        // Additional handling for side-by-side view
        if (this.twoColumns) {
          this.forceResizePdfViewers();
        }

        // Restore analysis type if it was an AI-related type
        if (['ai', 'metadata', 'stylometrics', 'projectSynapse'].includes(currentAnalysisType)) {
          setTimeout(() => {
            this.reportService.selectAnalysisTypeSubject.next(currentAnalysisType);
          }, 100);
        }
      }, 100);
    }
  }

  // Enhance the updateViewerSize method to ensure proper PDF viewer sizing
  private updateViewerSize() {
    requestAnimationFrame(() => {
      const viewers = document.querySelectorAll('.pdf-viewer-container');
      const mainContainer = document.querySelector('.document-container') as HTMLElement;

      if (mainContainer) {
        // Calculate sidebar width based on collapsed state
        const sidebarWidth = this.sideBarCollapsed ? 80 : 630;
        const padding = 32;
        const gap = 16;
        const minWidth = 600; // Minimum width constant

        // Calculate container width as a percentage of available space
        const availableWidth = Math.max(window.innerWidth - sidebarWidth - padding, minWidth);
        mainContainer.style.width = '100%';
        mainContainer.style.minWidth = `${minWidth}px`;
        mainContainer.style.maxWidth = `${availableWidth}px`;
        mainContainer.style.overflowX = 'auto';
        mainContainer.style.paddingRight = `${padding / 2}px`;
        mainContainer.style.paddingLeft = `${padding / 2}px`;

        if (this.twoColumns) {
          // For two columns, ensure each column has minimum width
          const columnWidth = Math.max((availableWidth - gap) / 2, minWidth);

          viewers.forEach(viewer => {
            const viewerElement = viewer as HTMLElement;
            viewerElement.style.width = `calc(50% - ${gap / 2}px)`;
            viewerElement.style.minWidth = `${minWidth}px`;
            viewerElement.style.maxHeight = 'calc(100vh - 32px)';
            viewerElement.style.overflow = 'auto';

            // Force width on the internal PDF viewer elements
            const pdfViewerContainers = viewerElement.querySelectorAll('.ng2-pdf-viewer-container');
            pdfViewerContainers.forEach((container: Element) => {
              (container as HTMLElement).style.width = '100% !important';
              (container as HTMLElement).style.minWidth = `${minWidth}px !important`;
            });

            // Also update the canvas elements directly to ensure proper sizing
            const canvasContainers = viewerElement.querySelectorAll('.page');
            canvasContainers.forEach((container: Element) => {
              (container as HTMLElement).style.width = '100%';
              (container as HTMLElement).style.minWidth = `${minWidth}px`;
              (container as HTMLElement).style.maxWidth = '100%';
            });
          });

          // Add CSS for responsive handling
          const style = document.createElement('style');
          style.id = 'pdf-viewer-fix';
          style.textContent = `
            .pdf-viewer-container.half-width {
              width: calc(50% - ${gap / 2}px) !important;
              min-width: ${minWidth}px !important;
            }
            .pdf-viewer-container.half-width .ng2-pdf-viewer-container {
              width: 100% !important;
              min-width: ${minWidth}px !important;
            }
            .pdf-viewer-container.half-width .page {
              width: 100% !important;
              min-width: ${minWidth}px !important;
              max-width: 100% !important;
            }
            .document-container {
              min-width: ${minWidth}px !important;
              max-width: ${availableWidth}px !important;
              overflow-x: auto !important;
            }
          `;

          const existingStyle = document.getElementById('pdf-viewer-fix');
          if (existingStyle) {
            existingStyle.remove();
          }
          document.head.appendChild(style);
        } else {
          // For single column, use full width
          viewers.forEach(viewer => {
            const viewerElement = viewer as HTMLElement;
            viewerElement.style.width = '100%';
            viewerElement.style.maxHeight = 'calc(100vh - 32px)';
            viewerElement.style.overflow = 'auto';

            // Reset any inline styles added for two-column mode
            const pdfViewerContainers = viewerElement.querySelectorAll('.ng2-pdf-viewer-container');
            pdfViewerContainers.forEach((container: Element) => {
              (container as HTMLElement).style.width = '100%';
            });

            const canvasContainers = viewerElement.querySelectorAll('.page');
            canvasContainers.forEach((container: Element) => {
              (container as HTMLElement).style.width = '100%';
              (container as HTMLElement).style.maxWidth = '100%';
            });
          });

          // Add responsive styles for single column view
          const style = document.createElement('style');
          style.id = 'pdf-viewer-fix';
          style.textContent = `
            .document-container {
              width: 100% !important;
              max-width: ${availableWidth}px !important;
            }
            .pdf-viewer-container {
              width: 100% !important;
            }
            .page {
              width: 100% !important;
              max-width: 100% !important;
            }
            @media (min-width: 600px) and (max-width: 800px) {
              .document-container {
                max-width: 900px !important;
                overflow-x: auto !important;
              }
            }
          `;

          // Replace any existing style
          const existingStyle = document.getElementById('pdf-viewer-fix');
          if (existingStyle) {
            existingStyle.remove();
          }
          document.head.appendChild(style);
        }

        // Force layout update after all adjustments
        this.cdr.detectChanges();
      }
    });
  }

  // Add this method to explicitly resize the PDF viewers when going to side-by-side mode
  private forceResizePdfViewers() {
    setTimeout(() => {
      // Programmatically set zoom scale to ensure proper rendering
      if (this.viewer?.nativeElement) {
        const viewerDiv = this.viewer.nativeElement.querySelector('div');
        if (viewerDiv) {
          viewerDiv.style.transform = '';
        }
      }

      if (this.viewerSecond?.nativeElement) {
        const viewerSecondDiv = this.viewerSecond.nativeElement.querySelector('div');
        if (viewerSecondDiv) {
          viewerSecondDiv.style.transform = '';
        }
      }

      // Force ng2-pdf-viewer to recalculate its layout
      window.dispatchEvent(new Event('resize'));

      // Update viewer size after a small delay
      setTimeout(() => {
        this.updateViewerSize();
      }, 50);
    }, 100);
  }

  removeHighlight() {
    let viewer = document.getElementById('viewer') as HTMLElement;
    let viewerSecond = document.getElementById('viewerSecond') as HTMLElement;

    this.markInstance = new Mark(viewer);
    this.markInstance.unmark();

    if (this.isProjectSynapseActive && viewerSecond) {
      let markInstanceSecond = new Mark(viewerSecond);
      markInstanceSecond.unmark();
    }

    // Remove all section numbers and their wrappers
    document.querySelectorAll('.section-number').forEach((item) => {
      const wrapper = item.parentElement;
      if (wrapper) {
        wrapper.remove();
      }
    });

    // Remove all markQuote elements
    document.querySelectorAll('.markQuote').forEach((item) => {
      item.remove();
    });

    // Clear the numbered sections tracking
    this.numberedSections.clear();

    // Reset active section
    this.activeSection = null;
  }

  onPdfLoad(pdf: PDFDocumentProxy): void {
    this.totalPages = pdf.numPages;
    this.documentDataService.setTotalPages(this.totalPages)
    this.spinnerService.hide()

    // Force resize after PDF loads
    setTimeout(() => {
      this.updateViewerSize();
      window.dispatchEvent(new Event('resize'));

      // Add immediate highlighting after PDF loads when in Project Synapse mode
      if (this.isProjectSynapseActive) {
        this.removeHighlight();
        this.doAIHighlight(1); // Start with first page
      }
    }, 100);
  }


  pageChanging(e: any) {
    this.page = e.pageNumber;
    this.documentDataService.setCurrentScrollingPage(this.page);

    // Only synchronize scroll if we're in two-column mode
    if (this.twoColumns) {
      // Prevent infinite scroll synchronization loop
      if (!this.isScrollingSynced) {
        this.isScrollingSynced = true;

        // Set timeout to prevent browser rendering bottlenecks
        setTimeout(() => {
          // Call appropriate highlight method
          if (this.isProjectSynapseActive) {
            this.doAIHighlight(this.page);
          } else {
            this.callHighlight(this.page);
          }

          // Reset synchronization lock
          this.isScrollingSynced = false;
        }, 50);
      }
    } else {
      // Single column mode - normal behavior
      if (this.isProjectSynapseActive) {
        this.doAIHighlight(this.page);
      } else {
        this.callHighlight(this.page);
      }
    }
  }

  calculateNextPage(currentPage: any) {
    this.documentDataService.setCurrentScrollingPage(this.page);
    if (this.loadedPagesId.length === 0) {
      return;
    }

    this.pagesToDraw = [];
    this.pagesToDestroy = [];

    const { numberOfDifference, loadedPages, loadedPagesId } = this;
    const lowest = currentPage - numberOfDifference;
    const highest = currentPage + numberOfDifference;

    for (const pageId of loadedPagesId) {
      if (pageId <= highest && pageId >= lowest) {
        this.pagesToDraw.push(pageId);
      } else {
        this.pagesToDestroy.push(pageId);
      }
    }

    for (const pageToDestroy of this.pagesToDestroy) {
      const index = this.loadedPages.findIndex((page) => (page as any).id === pageToDestroy);

      if (index !== -1) {
        (this.loadedPages[index] as any).destroy();
        this.loadedPages.splice(index, 1);
      }
    }

    if (this.loadedPagesId.length >= 6) {
      const destroyIndex = this.loadedPagesId.indexOf(this.pagesToDestroy[0]);

      if (destroyIndex !== -1) {
        this.loadedPagesId.splice(destroyIndex, 1);
        this.pagesToDestroy.splice(0, 1);
      }
    }

    // if (this.analysisType != 'none') {
    setTimeout(() => {
      if (this.oldPage > currentPage && currentPage - 1 <= 1) {
        this.callHighlight(currentPage - 1);
      } else {
        this.callHighlight(currentPage);
      }

      this.oldPage = currentPage;

    }, 200);
    // }
  }

  // Add this method to handle the completion of page change initiated by scrolling
  // handleScrollingPageChangeComplete() {
  //   // Check if the page change is not initiated by a navigation button click
  //   if (!this.documentDataService.getNavigationClickedSubject()) {
  //     this.documentDataService.setCurrentPage(this.page);
  //   }
  // }

  callHighlight(currentPage: any) {
    this.notFound = [];
    if (this.analysisType !== 'metadata' && this.analysisType != 'stylometrics' && this.analysisType !== 'isOnCohort') {
      if (this.analysisType === 'projectSynapse') {
        this.reportService.selectAnalysisTypeSubject.next('projectSynapse');
        this.stylometricState.forceProjectSynapseState(true);
      } else if (this.analysisType != 'none') {
        if (!this.displayAiText && !this.isOnManipulation) {
          // console.log(this.activePlagSources, 'activePlagSources');

          const arrayToHighlight = this.activePlagSources;
          if (arrayToHighlight) {
            for (let source of arrayToHighlight) {
              for (let sentence of source.sentences) {
                const shouldHighlight = currentPage === sentence.page &&
                  (this.highlightQuotes || !sentence.isCitation);
                const isSelectedOrNoSelection = this.selectedSources.length === 0 || this.selectedSources.includes(source.no);

                if (shouldHighlight && isSelectedOrNoSelection) {
                  this.doHighlight(sentence.text, sentence, this.notFound, source);
                }
              }
            }
          }
        } else if (this.isOnManipulation) {
          const arrayToHighlight = this.sentenceDetails;

          for (let sentence of arrayToHighlight) {
            const shouldHighlight = currentPage === sentence.page;

            if (this.selectedManipulation === 'isImage') {
              return;
            } else if (this.selectedManipulation === 'charReplacement') {
              if (shouldHighlight && sentence.replacedCharacters && sentence.replacedCharacters.length > 0) {
                sentence.replacedCharacters.forEach((char: any) => {
                  this.doHighlight(char, sentence, this.notFound, null);
                });
              }
            } else if (this.selectedManipulation === 'hiddenText') {
              if (shouldHighlight && sentence.characters.length > 0) {
                this.doHighlight(sentence.text, sentence, this.notFound, []);
              }
            }
          }
        } else if (this.displayAiText) {
          this.aiHighlights();
        } else {
          const arrayToHighlight = this.activePlagSources;
          if (arrayToHighlight) {
            for (let source of arrayToHighlight) {
              for (let sentence of source.sentences) {
                const shouldHighlight = currentPage === sentence.page &&
                  (this.highlightQuotes || !sentence.isCitation);
                const isSelectedOrNoSelection = this.selectedSources.length === 0 || this.selectedSources.includes(source.no);

                if (shouldHighlight && isSelectedOrNoSelection) {
                  this.doHighlight(sentence.text, sentence, this.notFound, source);
                }
              }
            }
          }
        }
      } else {
        if (this.summaryDetails) {
          if (!Array.isArray(this.summaryDetails)) {
            this.reportComponent.getTransformData();
          }

          const arrayToHighlight = this.summaryDetails;
          if (arrayToHighlight && Array.isArray(arrayToHighlight)) {
            for (let sentence of arrayToHighlight) {
              const shouldHighlight = currentPage === sentence.page &&
                (this.highlightQuotes || !sentence.isCitation);

              if (shouldHighlight) {
                this.doHighlight(sentence.text, sentence, this.notFound, []);
              }
            }
          }
        }
      }
    }
    if (this.notFound.length !== 0) {
      this.getTextFromPages();
    }
  }

  setNodeBackground(node, data) {
    let correctData = data;
    if (!this.isOriginalLanguage) {
      // Check if translated findings exist and select the appropriate translation based on language
      if (correctData.translatedFindings && correctData.translatedFindings[this.selectedTransltaionCode]) {
        correctData = correctData.translatedFindings[this.selectedTransltaionCode];
      } else if (correctData.translatedFindings && Object.keys(correctData.translatedFindings).length > 0) {
        correctData = correctData.translatedFindings[Object.keys(correctData.translatedFindings)[0]];
      }
    }

    // Extract necessary data
    const similarity = correctData.primarySource.percentage;
    const proximity = correctData.primarySource?.averageDistance / 100 || 0;
    const contextSimilarity = parseFloat(correctData.primarySource?.contextSimilarityPercentage) || 0;
    const sourceType = correctData.primarySource?.type;

    // Set background colors based on the conditions
    // First check for excluded and citation cases (these remain unchanged)
    if (this.isOriginalLanguage ? (data.isExcluded || data.primarySource.isExcluded) : (correctData.isTranslationExcluded || correctData.primarySource.isExcluded)) {
      node.style.background = 'rgb(128, 128, 128, 0.45)'; // Gray color for Excluded
    } else if (data.isCitation) {
      node.style.background = 'rgba(77, 211, 155, 0.45)'; // Green color for Citation
    }
    // Then check if we can use the new logic based on primarySource.type
    else if (sourceType !== undefined) {
      // Use the new logic based on primarySource.type
      if (sourceType === 1) {
        node.style.background = 'rgba(255, 145, 182, 0.45)'; // Red color for Exact Match
      } else if (sourceType === 2) {
        node.style.background = 'rgba(59, 152, 246, 0.45)'; // Blue color for Altered text
      } else if (sourceType === 3) {
        node.style.background = 'rgb(255, 199, 88, 0.45)'; // Yellow color for Context similarity
      }
    }
    // Only use the old logic as a fallback when primarySource.type doesn't exist
    else {
      // Fallback to original logic
      if (similarity === 100 || (similarity >= (this.submission?.sentence_thresholds?.exactMatchThreshold || 80) && proximity < 2.00)) {
        node.style.background = 'rgba(255, 145, 182, 0.45)'; // Red color for Exact Match
      } else if ((similarity >= (this.submission.sentence_thresholds.alteredTextThreshold || 60) && similarity < (this.submission.sentence_thresholds.exactMatchThreshold || 80) && proximity < 2.00) ||
        (similarity >= (this.submission.sentence_thresholds.alteredTextThreshold || 60) && proximity >= 2.00 && proximity <= 3.00 && contextSimilarity > (this.submission.sentence_thresholds.contextualSimilaritiesThreshold || 80))) {
        node.style.background = 'rgba(59, 152, 246, 0.45)'; // Blue color for Altered text
      } else if (this.context_similarity ? contextSimilarity > (this.submission.sentence_thresholds.contextualSimilaritiesThreshold || 80) : false) {
        node.style.background = 'rgb(255, 199, 88, 0.45)'; // Yellow color for Context similarity
      }
    }

    return node
  }


  doHighlight(stringToHighlight: any, objToHighlight: any, notFound: any, source: any, identicalSentence?: any) {
    let mark = 0;
    let viewer = document.getElementById(`viewer`);
    const replacedCharsToHighlight = this.allManipulations?.replacedCharacters?.map((char: any) => char.character);
    this.markInstance = new Mark(viewer as any);

    if (this.page === objToHighlight.page) {
      let searchOptions = {
        acrossElements: true,
        separateWordSearch: false,
        limit: 1,
        exclude: ['.canvasWrapper', '[data-markjs="true"]'],
        each: (element: any) => {
          if (mark == 0) {
            let elementRect = element.getBoundingClientRect();
            let viewerRect = viewer.getBoundingClientRect();

            setTimeout(() => {
              let highlightedElements = document.querySelectorAll(`mark[sentence-id="${objToHighlight.id}"]`);
              if (highlightedElements.length > 0) {
                let topValues = Array.from(highlightedElements).map((el: any) => {
                  let spanElement = el.parentElement;
                  let styleNode = spanElement.attributes.style.nodeValue;
                  let topValueMatch = styleNode.match(/top:\s*([\d.]+)px/);
                  let topValue = topValueMatch ? parseFloat(topValueMatch[1]) : 0;
                  return topValue;
                });

                let minTopValue;

                if (topValues.length > 1) {
                  let differences = topValues.map((value, index, array) => {
                    if (index > 0) {
                      return Math.abs(value - array[index - 1]);
                    } else {
                      return 0;
                    }
                  });

                  let averageDifference = differences.reduce((a, b) => a + b, 0) / (differences.length - 1);

                  if (averageDifference > 300) {
                    minTopValue = Math.max(...topValues);
                  } else {
                    minTopValue = Math.min(...topValues);
                  }
                } else {
                  minTopValue = Math.min(...topValues);
                }
                var node = document.createElement('SPAN');
                node.classList.add('markQuote');

                if (this.analysisType === 'none') {
                  let isLeftSide = elementRect.left + elementRect.width / 2 < viewerRect.left + viewerRect.width / 2;
                  if (isLeftSide) {
                    node.classList.add('left');
                    node.style.left = '15px';
                  } else {
                    node.classList.add('right');
                    node.style.right = '45px';
                  }

                  node.style.top = `${minTopValue}px`;
                }
                node.style.position = 'absolute';

                let overlapping = false;
                document.querySelectorAll('.markQuote.on_summary').forEach((existingNode: any) => {
                  let existingRect = existingNode.getBoundingClientRect();
                  if (node.getBoundingClientRect().top < existingRect.bottom && node.getBoundingClientRect().bottom > existingRect.top) {
                    overlapping = true;
                  }
                });

                if (overlapping) {
                  node.style.top = `${minTopValue + 20}px`;
                }


                if (this.analysisType == 'none') {
                  $(node).addClass('on_summary');
                  element.style.position = 'relative';
                  element.style.zIndex = '10';
                  let section = document.createElement('section');
                  section.classList.add('summaryHighlight-btns');
                  $(section).attr('data-sentence-id', objToHighlight.id);
                  $(section).on('click', () => {
                    const elementWithId = document.querySelector(`[sentence-id="${objToHighlight.id}"]`) as HTMLElement;
                    this.activateButton(elementWithId, objToHighlight)
                  })

                  $(section).on('keydown', (e) => {
                    if (e.key === 'Enter') {
                      const elementWithId = document.querySelector(`[sentence-id="${objToHighlight.id}"]`) as HTMLElement;
                      this.activateButton(elementWithId, objToHighlight)
                    }
                  });

                  // Create svg element
                  let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                  svg.classList.add('connection-line');
                  section.appendChild(svg);
                  let insideSection = document.createElement('div');
                  insideSection.classList.add('summary-section');
                  section.appendChild(insideSection);

                  for (let i = 0; i <= 3; i++) {
                    let summary_ui = document.createElement('div');
                    summary_ui.classList.add('summary-ui');

                    insideSection.appendChild(summary_ui);
                  }
                  if (objToHighlight.isOriginal || objToHighlight.isTranslated || objToHighlight.isAi || objToHighlight.isManipulated.isManipulated) {
                    if (objToHighlight.isOriginal && !objToHighlight.isExcluded && !objToHighlight.source.isExcluded) {
                      insideSection.children[0].classList.add('filled');
                    }

                    if (objToHighlight.isTranslated && objToHighlight.translated.length > 0) {
                      const hasIncludedTranslation = objToHighlight.translated.some(element => !element.isExcluded);
                      if (hasIncludedTranslation) {
                        insideSection.children[1].classList.add('filled');
                      }
                    }

                    if (objToHighlight.isAi) {
                      insideSection.children[2].classList.add('filled');
                    }

                    if (objToHighlight.isManipulated.isManipulated && (objToHighlight.manipulations[0]?.includedCharacters?.length > 0 || objToHighlight?.manipulations[0]?.excludedReplacedCharacters?.length > 0 || !objToHighlight?.manipulations[1]?.isExcluded)) {
                      insideSection.children[3].classList.add('filled');
                    }

                    if (objToHighlight.isManipulated?.isManipulated && (objToHighlight.manipulations[0]?.includedCharacters?.length > 0 || objToHighlight?.manipulations[0]?.excludedCharacters?.length > 0 || !objToHighlight?.manipulations[1]?.isExcluded)) {
                      insideSection.children[3].classList.add('filled');
                    }


                    var inside_btns = document.createElement('div');
                    inside_btns.classList.add('inside_btns');
                    section.appendChild(inside_btns);

                    node.appendChild(section);
                    element?.parentElement?.parentElement?.appendChild(node);

                    // Connect the SVG line from the span element to the last highlighted element
                    let firstHighlightedElement = highlightedElements[0];
                    let lastHighlightedElement = highlightedElements[highlightedElements.length - 1];
                    let line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
                    let spanRect = node.getBoundingClientRect();
                    let highlightRect = lastHighlightedElement.getBoundingClientRect();

                    line.setAttribute('x1', `${spanRect.left + spanRect.width / 2}`);
                    line.setAttribute('y1', `${spanRect.top + spanRect.height / 2}`);
                    line.setAttribute('x2', `${highlightRect.left + highlightRect.width / 2}`);
                    line.setAttribute('y2', `${highlightRect.top + highlightRect.height / 2}`);

                    line.setAttribute('stroke', 'black');
                    line.setAttribute('stroke-width', '2');
                    svg.appendChild(line);
                  }
                } else {
                  if (this.isOnManipulation) {
                    if (this.selectedManipulation === 'hiddenText') {
                      let height = element.offsetHeight;
                      if (height < 10) {
                        var textnode = document.createTextNode('Small Hidden Text');
                        node.appendChild(textnode);
                        node.classList.add('smallHiddenText');
                        element.appendChild(node);
                      }
                    }
                  } else {
                    node = this.setNodeBackground(node, objToHighlight)
                    if (
                      (!source.hide || source.hide === false) &&
                      !source.isExcluded
                    ) {
                      var textnode = document.createTextNode(source.no);
                      node.appendChild(textnode);
                      element.appendChild(node);
                    }
                  }
                }
              }
            }, 0);
          }
          mark = 1;
          element.style.color = 'transparent';
          element.style.position = 'relative';

          if (this.analysisType == 'none') {
            const shouldMarkGray = (() => {
              // Case 1: If AI is true, sentence should not be marked gray
              if (objToHighlight.isAi) return false;

              // Check if the original is excluded
              const isOriginalExcluded = objToHighlight.isOriginal && (objToHighlight.isExcluded || objToHighlight.source.isExcluded);

              // Check if there are any translated findings
              const hasTranslatedFindings = Array.isArray(objToHighlight.translated) && objToHighlight.translated.length > 0;

              // Check if all translated findings are excluded
              const areAllTranslationsExcluded = objToHighlight.translated?.every((trans: any) => (trans?.isExcluded || trans?.source?.isExcluded));

              // Check if all manipulations are excluded
              const areAllManipulationsExcluded = Array.isArray(objToHighlight.manipulations) && objToHighlight.manipulations.length > 0 ?
                objToHighlight.manipulations.reduce((acc: boolean, manip: any) => {
                  if (!manip) return acc;

                  if (manip.hasOwnProperty('isExcluded')) {
                    return acc && manip.isExcluded;
                  } else if (manip.hasOwnProperty('includedCharacters') && manip.hasOwnProperty('excludedReplacedCharacters')) {
                    return acc &&
                      Array.isArray(manip.includedCharacters) &&
                      Array.isArray(manip.excludedReplacedCharacters) &&
                      manip.includedCharacters.length === 0 &&
                      manip.excludedReplacedCharacters.length > 0;
                  }
                  return acc;
                }, true) : false;

              // Case 1: Original is excluded, no translations, no manipulations
              if (isOriginalExcluded && !hasTranslatedFindings && !objToHighlight.isManipulated?.isManipulated) {
                return true;
              }

              // Case 2: Original is excluded, has translations, and all translations are excluded
              if (isOriginalExcluded && hasTranslatedFindings && areAllTranslationsExcluded && !objToHighlight.isManipulated?.isManipulated) {
                return true;
              }

              // Case 3: No original, only translations, and all translations are excluded
              if (!objToHighlight.isOriginal && hasTranslatedFindings && areAllTranslationsExcluded && !objToHighlight.isManipulated?.isManipulated) {
                return true;
              }

              // Final Case: If original is excluded and all translations and manipulations are excluded, mark gray
              if (isOriginalExcluded && areAllManipulationsExcluded && (!hasTranslatedFindings || areAllTranslationsExcluded)) {
                return true;
              }

              // Default to false if none of the conditions are met
              return false;
            })();

            $(element).attr('sentence-id', objToHighlight.id);
            $(element).addClass('sentence-' + objToHighlight.id);
            $(element).attr('tabindex', '0');
            if (shouldMarkGray) {
              element.style.background = 'rgba(128, 128, 128, 0.45)';
              $(element).attr('excluded', 'true');
            } else {
              if (objToHighlight.isOriginal || objToHighlight.isTranslated || objToHighlight.isAi || objToHighlight.isManipulated.isManipulated) {
                element.style.background = 'rgba(255, 45, 45, 0.25)';
              }

              if (!objToHighlight.isOriginal && !objToHighlight.isTranslated && (!objToHighlight.isAi || objToHighlight.isAi == undefined) && !objToHighlight.isManipulated.isManipulated) {
                $(element).attr('excluded', 'true');
                element.style.background = 'rgba(128, 128, 128, 0.45)';
              }
            }


            $(element).on('click', (e) => {
              this.activateButton(element, objToHighlight)
            });
            $(element).on('keydown', (e) => {
              if (e.key === 'Enter') {
                this.activateButton(element, objToHighlight)
              }
            });
          }
          else {
            if (this.isOnManipulation) {
              if (this.selectedManipulation === 'charReplacement') {
                if (replacedCharsToHighlight.some((char: any) => stringToHighlight.includes(char))) {
                  element.style.background = 'rgba(255, 81, 81, 0.45)';
                } else {
                  element.style.background = 'rgba(128, 128, 128, 0.45)';
                }
                element.style.cursor = 'default';
              } else if (this.selectedManipulation === 'hiddenText') {
                if (objToHighlight.characters.length > 0) {
                  if (!objToHighlight.whitecharactersExcluded) {
                    element.style.background = 'rgba(255, 208, 0, 0.45)';
                  } else {
                    element.style.background = 'rgba(128, 128, 128, 0.45)';
                  }
                  element.style.cursor = 'pointer';
                  $(element).on('click', () => {
                    this.openSentenceInformation(objToHighlight, 'hiddenText');
                  });
                }
              }
            }
            else {
              if (this.displayAiText) {
                element.style.background = 'rgba(163, 137, 228, 0.45)';
                if (objToHighlight.model_1) {
                  element.style.background = 'rgba(163, 137, 228, 0.45)';
                }
              } else {
                element = this.setNodeBackground(element, objToHighlight)
              }
              $(element).css('cursor', 'pointer');
              $(element).attr('data-source-id', source.sourceId);
              $(element).attr('data-page-number', objToHighlight.page);
              $(element).attr('sentence-id', objToHighlight.id);
              $(element).attr('source-no', source.no);
              $(element).attr('tabindex', '0');
              $(element).attr('aria-label', 'This text is ' + (objToHighlight.isCitation ? 'a quotation' : objToHighlight.isExcluded ? 'excluded' : objToHighlight.sourceSentencePercentage < this.exactMatchThreshold ? ' possibly altered' : 'an exact match') + '. Press enter to open the modal');

              if (!this.displayAiText) {
                $(element).on('click', (e) => {
                  this.sourceId = e.target.attributes['data-source-id'].value;
                  this.sentenceId = e.target.attributes['sentence-id'].value;
                  let sourceNo = e.target.attributes['source-no'].value || 1;
                  let result;
                  this.activePlagSources.forEach((element: any) => {
                    element.sentences.forEach((sentence: any) => {
                      if (sentence.id == this.sentenceId) {
                        result = sentence;
                      }
                    });
                  });
                  this.openModal(result, sourceNo);
                });
                $(element).on('keydown', (e) => {
                  if (e.key === 'Enter') {
                    this.sourceId = e.target.attributes['data-source-id'].value;
                    this.sentenceId = e.target.attributes['sentence-id'].value;
                    let sourceNo = e.target.attributes['source-no'].value || 1;
                    let result;
                    this.activePlagSources.forEach((element: any) => {
                      element.sentences.forEach((sentence: any) => {
                        if (sentence.id == this.sentenceId) {
                          result = sentence;
                        }
                      });
                    });
                    this.openModal(result, sourceNo);
                  }
                });
              }
              if (!this.displayAiText) {
                element.addEventListener('click', (e) => {
                  this.openSentenceInformation(objToHighlight, 'indeepth');
                });

                element.addEventListener('keydown', (e) => {
                  if (e.key === 'Enter') {
                    this.openSentenceInformation(objToHighlight, 'indeepth');
                  }
                });
              }
            }
          }
          if (source?.isExcluded) {
            element.style.background = 'rgb(128, 128, 128, 0.45)';
          }
        },
        filter: function (txtNode: any, string: string, s: any, b: any) {
          return true;
        },
        noMatch: function (range: any) {
          notFound.push({ objToHighlight, source });
        },
      };

      this.markInstance.mark(stringToHighlight, searchOptions);
    }
  }

  activateButton(element: any, objToHighlight: any) {
    const currentElement = $(element);
    const sameElements = document.getElementsByClassName('sentence-' + objToHighlight.id);
    const allBtns = document.querySelectorAll('.summaryHighlight-btns');

    allBtns.forEach((btn: any) => {
      btn.classList.remove('active');
    });

    const btn = document.querySelector(`[sentence-id="${objToHighlight.id}"]`);

    if (this.currentlyHighlightedElement.includes(element)) {
      Array.from(sameElements).forEach((el: any) => {
        let isExcluded = el.hasAttribute('excluded');
        el.style.background = isExcluded ?
          'rgba(128, 128, 128, 0.45)' :
          'rgba(255, 45, 45, 0.25)';
        el.style.outline = 'none';
      });

      this.reportService.sentenceInformation(null, '', null);
      this.currentlyHighlightedElement = [];
      btn?.classList.remove('active');
    } else {
      if (this.currentlyHighlightedElement.length > 0) {
        const previouslyHighlightedClass = this.currentlyHighlightedElement[0].className;
        const previouslyHighlightedElements = document.getElementsByClassName(previouslyHighlightedClass);
        Array.from(previouslyHighlightedElements).forEach((el: any) => {
          let isExcluded = el.hasAttribute('excluded');
          el.style.background = isExcluded ?
            'rgba(128, 128, 128, 0.45)' :
            'rgba(255, 45, 45, 0.25)';
          el.style.outline = 'none';
        });
      }

      Array.from(sameElements).forEach((el: HTMLElement) => {
        let isExcluded = el.hasAttribute('excluded');
        el.style.background = isExcluded ?
          'rgba(128, 128, 128, 0.65)' :
          'rgba(255, 45, 45, 0.50)';
      });

      // Filter sourceHistory to remove sources with the same URL as the primary source
      if (objToHighlight?.sourceHistory && objToHighlight?.source?.url) {
        objToHighlight.sourceHistory = objToHighlight.sourceHistory.filter((url: string) =>
          url !== objToHighlight.source.url
        );
      }

      this.reportService.sentenceInformation(objToHighlight, '', null);
      this.currentlyHighlightedElement = [currentElement[0]];
    }
  }

  drawConnectionLine(button: HTMLElement, sentence: HTMLElement) {
    const buttonRect = button.getBoundingClientRect();
    const sentenceRect = sentence.getBoundingClientRect();

    const highlightedSentence = document.querySelector('.sentence-' + button.getAttribute('data-sentence-id')) as HTMLElement;

    if (highlightedSentence) {
      const sentenceRect = highlightedSentence.getBoundingClientRect();
      let viewer = document.getElementById(`viewer`);
      const viewerRect = viewer?.getBoundingClientRect();

      const svg = button.querySelector('.connection-line') as HTMLElement;
      while (svg.firstChild) {
        svg.removeChild(svg.firstChild);
      }
      const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');

      // ${elementRect.top - viewerRect.top + 15}px`
      // if button is  on the left side of the sentence
      if (buttonRect.left + buttonRect.width / 2 < sentenceRect.left + sentenceRect.width / 2) {
        line.setAttribute('x1', '30px');
        line.setAttribute('y1', `15px`);
        line.setAttribute('x2', `${sentenceRect.left - buttonRect.left}`);
        line.setAttribute('y2', `${buttonRect.top - sentenceRect.top}`);
        // line.classList.add('line-connector');
        // svg.appendChild(line);
      } else {
        line.setAttribute('x1', '0px');
        line.setAttribute('y1', '0px');
        line.setAttribute('x2', `${buttonRect.left - (sentenceRect.left + sentenceRect.width)}`);
        line.setAttribute('y2', '0px');
      }

      line.classList.add('line-connector');
      svg.appendChild(line);
    }
  }

  openModal(result: any, sourceNo: number) {
    // this.ref = this.dialogService.open(HighlightActions, {
    //   maximizable: true,
    //   keepInViewport: true,
    //   draggable: true,
    //   header: result.isCitation ? 'This is a quotation' : result.isExcluded ? 'This is a removed highlight' : result.sourceSentencePercentage < 84.5 ? 'This is Altered text' : 'This is an exact match',
    //   styleClass: 'modal',
    //   dismissableMask: true,
    //   data: {
    //     result,
    //     isOriginalLanguage: this.isOriginalLanguage,
    //     highlight_type: result.isCitation ? 'quotation' : result.isExcluded ? 'removed' : result.sourceSentencePercentage < 84.5 ? 'possibly_altered' : 'exact_match',
    //     sourceNo
    //   }
    // });
  }

  openManipulationsModal(result: any) {
    // this.ref = this.dialogService.open(ManipulationActions, {
    //   maximizable: true,
    //   keepInViewport: true,
    //   draggable: true,
    //   header: 'Hidden Text',
    //   styleClass: 'modal',
    //   dismissableMask: true,
    //   data: {
    //     result,
    //     submissionId: this.submissionId
    //   }
    // });
  }

  aiHighlights() {
    this.notFound = [];
    this.totalSentencesWithAI = 0;

    this.sentencesWithAI.forEach((element: any) => {
      if (element.aiText) {
        this.totalSentencesWithAI++;
        this.doHighlight(element.text, element, this.notFound, [])
      }
    })
  }

  handleManipulations() {
    this.removeHighlight()
    if (this.selectedManipulation === 'charReplacement') {
      this.pdfSrc = this.tempPdfSrc;
      // this.spinnerService.show();
      this.highlightCharacterReplacements();
    } else if (this.selectedManipulation === 'hiddenText') {
      this.pdfSrc = this.tempPdfSrc;
      this.highlightWhiteCharacters();
    } else if (this.selectedManipulation === 'isImage') {
      this.highlightImages();
    }

  }

  openSentenceInformation(sentence: any, viewMode: string) {
    if (sentence.secondarySources) {
      if (sentence.secondarySources.length > 0) {
        sentence.secondarySources = sentence.secondarySources.filter((source: any) => source.isExcluded === false);
      }
    }

    if (viewMode === 'summary') {
      // For summary view, we pass null as language code
      this.reportService.sentenceInformation(sentence, viewMode as any, null);
    } else if (viewMode === 'ai' && this.isProjectSynapseActive) {
      // For AI view, we pass null as language code
      this.reportService.sentenceInformation(sentence, viewMode as any, null);
    } else {
      let isTranslated: boolean;
      let translated = [];

      if (sentence.translatedFindings) {
        translated = Object.keys(sentence.translatedFindings).map((lang: any) => {
          const finding = sentence?.translatedFindings[lang];
          const allTranslatedPercentages = this.submission.translatedPercentages;

          // Filter sourceHistory to remove sources with the same URL as the primary source
          const filteredSourceHistory = finding?.sourceHistory ?
            finding.sourceHistory.filter((url: string) =>
              url !== finding?.primarySource?.url
            ) : [];

          return {
            lang,
            percentage: allTranslatedPercentages !== undefined ? (allTranslatedPercentages[lang].percentageWithoutQuotes ? allTranslatedPercentages[lang].percentageWithoutQuotes : allTranslatedPercentages[lang].percentage) : finding?.percentage,
            sentence: finding?.primarySource?.sourceSentence,
            source: finding?.primarySource,
            isExcluded: finding?.isTranslationExcluded,
            comment: finding?.translateComment,
            secondarySources: finding?.secondarySources,
            text: sentence?.translatedFindings[lang].translatedText,
            sourceHistory: filteredSourceHistory
          }
        });
        isTranslated = translated.some((item: any) => item.source);
      } else {
        const primaryTranslatedSource = sentence?.primaryTranslatedSource;

        // Filter sourceHistory to remove sources with the same URL as the primary source
        const filteredSourceHistory = sentence?.sourceHistory ?
          sentence.sourceHistory.filter((url: string) =>
            url !== primaryTranslatedSource?.url
          ) : [];

        translated = sentence?.translatedText
          ?
          [{
            lang: this.submission?.translatedLanguage,
            percentage: primaryTranslatedSource?.percentage,
            sentence: primaryTranslatedSource?.sourceSentence,
            source: primaryTranslatedSource,
            isExcluded: sentence?.isTranslationExcluded,
            comment: sentence?.translateComment,
            secondarySources: sentence?.secondarySources,
            text: sentence?.translatedText,
            sourceHistory: filteredSourceHistory
          }]
          :
          [];
        isTranslated = !!sentence?.translatedText;
      }

      function getManipulations(sentence: any) {

        let temp_manipulations = [];

        // For char replacements
        if (sentence?.replacedCharacters && sentence?.replacedCharacters.length > 0) {
          temp_manipulations.push({
            includedCharacters: sentence?.replacedCharacters,
            excludedReplacedCharacters: []
          });
        } else {
          temp_manipulations.push({
            includedCharacters: [],
            excludedReplacedCharacters: []
          });
        }

        // For hidden text (white characters)
        if (sentence?.characters?.length > 0) {
          temp_manipulations.push({
            characters: sentence?.characters,
            isExcluded: sentence?.whitecharactersExcluded
          });
        } else {
          temp_manipulations.push({
            characters: [],
            isExcluded: false
          });
        }

        return temp_manipulations;
      }

      // Filter sourceHistory for the original language case
      const originalSourceHistory = this.isOriginalLanguage && sentence?.sourceHistory ?
        sentence.sourceHistory.filter((url: string) =>
          url !== sentence?.primarySource?.url
        ) : sentence?.sourceHistory;

      // Get the translated sourceHistory
      const translatedSourceHistory = translated.find(t => t.lang === this.selectedTransltaionCode)?.sourceHistory || translated[0]?.sourceHistory;

      this.summaryDetails = {
        submissionId: this.submissionId,
        text: sentence?.text,
        sentence: sentence?.primarySource?.sourceSentence,
        source: sentence?.primarySource,
        comment: sentence?.comment,
        id: sentence?.id,
        isOriginal: sentence?.sourceSentence || sentence?.primarySource ? true : false,
        isTranslated: isTranslated,
        isManipulated: {
          isManipulated: this.allManipulations?.replacedCharacters && this.allManipulations?.replacedCharacters?.length > 0 || sentence?.characters?.length > 0,
          isCharReplacement: this.allManipulations?.replacedCharacters && this.allManipulations?.replacedCharacters?.length > 0,
          isHiddenText: sentence?.characters?.length > 0
        },
        isExcluded: sentence?.isExcluded,
        isAi: sentence?.aiText?.aiText,
        isCitation: sentence.isCitation,
        similarity: sentence?.primarySource?.percentage,
        page: sentence?.page,
        secondarySources: sentence?.secondarySources,
        manipulations: getManipulations(sentence),
        translated,
        sourceHistory: this.isOriginalLanguage ?
          originalSourceHistory :
          translatedSourceHistory
      };

      // When in 'indeepth' mode, pass the current selected language code explicitly
      this.reportService.sentenceInformation(this.summaryDetails, viewMode as any, this.selectedTransltaionCode);
    }
  }


  highlightCharacterReplacements() {
    this.calculateNextPage(1);
    // this.notFound = [];

    // this.sentenceDetails?.forEach((sentence: any) => {
    //     if (sentence.replacedCharacters && sentence.replacedCharacters.length > 0) {
    //       sentence.replacedCharacters.forEach((char: any) => {
    //         this.doHighlight(char, sentence, this.notFound, null);
    //       });
    //     }
    // this.spinnerService.hide();
    // });
  }
  highlightWhiteCharacters() {
    // this.notFound = [];
    this.calculateNextPage(1);
  }
  highlightImages() {
    this.pdfSrc = this.pdfImagesSrc;
    // console.log(this.pdfSrc, 'pdfSrc');

  }

  getTextFromPages() {
    let textForHighlight = [];
    let pageText = $($('[data-loaded="true"]')).text();
    // Use match to find all occurrences of the pattern, and check if the result is not null
    let matchResult = pageText.match(/((?:[A-Z][a-z]\.|\w\.\w.|.)*?(?:[.!?]|$))(?:\s+|$)/g);
    let arrayOfTexts = matchResult ? matchResult.map(string => string.trim()) : [];

    // Remove the last element if arrayOfTexts is not empty
    if (arrayOfTexts.length > 0) {
      arrayOfTexts.pop();
    }
    for (let x in this.notFound) {
      for (let j in arrayOfTexts) {
        let parsedSentences = arrayOfTexts[j];
        let notFoundWithRegEx = this.notFound[
          x
        ].objToHighlight.text.replace(/\s+/g, '');

        let successCounter = 0;
        let startSentence = 0;
        let endSentence = 0;
        let keepChecking = false;
        let found = false;
        let i = 0;
        let textToHighlight = '';

        while (i < parsedSentences.length && !found) {
          if (parsedSentences[i].indexOf(' ') != 0) {
            if (notFoundWithRegEx[successCounter] == parsedSentences[i]) {
              successCounter++;
              if (keepChecking == false) {
                startSentence = i;
                keepChecking = true;
              }
            } else {
              if (successCounter > 0) {
                i = i - 1;
              }
              successCounter = 0;
              keepChecking = false;
            }

            if (successCounter == notFoundWithRegEx.length) {
              endSentence = i;

              textToHighlight = parsedSentences.substring(
                startSentence,
                endSentence + 1
              );

              found = true;
              textForHighlight.push({
                textToHighlight: textToHighlight,
                obj: this.notFound[x].objToHighlight,
                source: this.notFound[x].source,
              });
            }
          }
          i++;
        }
      }
    }
    this.notFound = [];
    for (let x in textForHighlight) {
      this.doHighlight(
        textForHighlight[x].textToHighlight,
        textForHighlight[x].obj,
        this.notFound,
        textForHighlight[x].source
      );
    }
  }


  pageRendered(e: any): void {
    if (e.pageNumber === 1) {
      setTimeout(() => {
        if (this.isProjectSynapseActive) {
          this.doAIHighlight(1);
          // Re-apply active section after highlights are added only for page 1
          if (this.activeSection) {
            setTimeout(() => this.applyActiveSection(this.activeSection), 300);
          }
        } else {
          this.callHighlight(1);
        }
        if (this.analysisType !== 'isOnCohort') {
          this.callHighlight(1)
        }
      }, 1000);
    }

    // Add highlighting for other pages too
    setTimeout(() => {
      if (this.isProjectSynapseActive) {
        this.doAIHighlight(e.pageNumber);

        // Handle any pending section scroll after the page is rendered
        if (this._pendingSectionScroll && !this._applyActiveSectionAttempts) {
          setTimeout(() => {
            if (this._pendingSectionScroll) {
              this.syncScrollToSection(this._pendingSectionScroll);
            }
          }, 500);
        }
        // Only apply active section for the current page if it's not the first page
        // and we're not already processing an active section
        else if (this.activeSection && e.pageNumber !== 1 && !this._applyActiveSectionAttempts) {
          setTimeout(() => this.applyActiveSection(this.activeSection), 300);
        }
      } else {
        this.callHighlight(e.pageNumber);
      }
    }, 200);

    this.pdfLoadedPages = [];
    this.notFound = [];

    this.documentPages = e.pageNumber;


    const sourceId: any = e.source.id;

    if (this.loadedPages.length === 0 || !this.loadedPages.some(page => (page as any).id === e.source.id)) {
      this.loadedPagesId.push(sourceId);
      this.loadedPages.push(e.source);
    }
    // this.callHighlight(1)

    if (this.notFound.length !== 0) {
    }

  }


  scrollPage(page: any) {
    const pageNumber = typeof page === 'string' ? parseInt(page, 10) : page;
    this.selectedPage = pageNumber;
    if (this.selectedPage == pageNumber && pageNumber !== this.page) {
      this.selectedPage = pageNumber - 1;
      setTimeout(() => {
        this.selectedPage = pageNumber;
        this.page = pageNumber
      }, 100);
    }
    setTimeout(() => {
      if (this.isProjectSynapseActive) {
        this.doAIHighlight(this.selectedPage);
      } else {
        this.callHighlight(this.selectedPage);
      }
    }, 500);
  }

  // Add this function if needed
  // private highlightPages(): void {
  //   let arrayToHighlight = this.selectedSources ? this.sources : this.activePlagSources;

  //   for (let source of arrayToHighlight) {
  //     for (let sentence of source.sentences) {
  //       this.handleSentenceHighlight(sentence);
  //     }
  //   }
  // }

  // Add this function if needed
  // private handleSentenceHighlight(sentence: any): void {
  //   let j = this.plagiarismLabels.length;

  //   if (sentence.page < j) {
  //     j = sentence.page;
  //   }

  //   let sentenceCopy = { ...sentence };

  //   if (this.shouldHighlightSentence(sentenceCopy)) {
  //     this.doHighlight(sentenceCopy.text, sentenceCopy, this.notFound, source);
  //   }
  // }

  // Add this function if needed
  // private shouldHighlightSentence(sentence: any): boolean {
  //   if (this.highlighQuotes === true) {
  //     return this.loadedPagesId.includes(sentence.page);
  //   } else {
  //     return this.loadedPagesId.includes(sentence.page) && sentence.isCitation === null;
  //   }
  // }

  zoomIn() {
    this.zoom += 0.1;
  }

  zoomOut() {
    this.zoom -= 0.1;
  }


  ngOnDestroy(): void {
    // Clean up all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.currentPageSubscription.forEach(sub => sub.unsubscribe());
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Add new helper method to generate ARIA labels
  private getSentenceAriaLabel(sentence: any): string {
    const labels = [];

    // Basic classification
    if (sentence.isCitation) {
      labels.push('quotation');
    } else if (sentence.isExcluded) {
      labels.push('excluded text');
    } else if (sentence.isAi) {
      labels.push('AI-generated text');
    } else if (sentence.sourceSentencePercentage >= this.exactMatchThreshold) {
      labels.push('exact match');
    } else {
      labels.push('possibly altered text');
    }

    // Add source information if available
    if (sentence.source?.no) {
      labels.push(`from source ${sentence.source.no}`);
    }

    // Add page information
    if (sentence.page) {
      labels.push(`on page ${sentence.page}`);
    }

    // Add similarity percentage if available
    if (sentence.sourceSentencePercentage) {
      labels.push(`${sentence.sourceSentencePercentage}% match`);
    }

    return `${labels.join(', ')}. Press Enter to view details`;
  }

  openStylometrics() {
    this.showStylometrics = !this.showStylometrics;
  }

  ttc() {
    this.twoColumns = !this.twoColumns;
  }

  // Update getZoomScale to handle both single and dual column modes
  getZoomScale(): string {
    // Always return 'page-fit' to ensure proper sizing in all modes
    return 'page-fit';
  }

  // Add a new method to check if second viewer should be shown
  canShowSecondViewer(): boolean {
    return this.isProjectSynapseActive && !!this.secondPdfSrc;
  }

  // Add this helper function to normalize text
  private normalizeText(text: string): string[] {
    // First normalize whitespace and line breaks
    const cleanText = text
      .replace(/\s+/g, ' ')  // normalize multiple spaces to single space
      .replace(/(\r\n|\n|\r)/gm, ' ')  // normalize line breaks to space
      .trim();  // trim any leading/trailing whitespace

    // Split into sentences more reliably
    const sentences = cleanText
      // First split on obvious sentence boundaries
      .split(/(?<=[.!?])\s+/)
      // Then filter out empty strings and clean each sentence
      .map(sentence => sentence.trim())
      .filter(sentence => sentence.length > 0);

    // Handle special cases like numbers with periods
    return sentences.map(sentence => {
      // Remove any remaining whitespace anomalies
      return sentence
        .replace(/\s+/g, ' ')
        .trim();
    });
  }

  doAIHighlight(page: number, noMatch?: any) {
    if (!noMatch) {
      // Save current active section before clearing highlights
      const currentActiveSection = this.activeSection;

      // Only clear numbered sections if this is a fresh highlight (not a noMatch case)
      this.removeHighlight();

      // Restore active section value after cleanup
      this.activeSection = currentActiveSection;

      // Store filtered entries when doing initial highlighting, maintaining original order
      this.sortedSynapseEntries = this.projectSynapseComparison ? Object.entries(this.projectSynapseComparison)
        .filter(([_, sectionData]: [string, any]) => sectionData.ai_text === true) : [];
    }

    const viewer = document.getElementById('viewer');
    const viewerSecond = document.getElementById('viewerSecond');

    this.markInstance = new Mark(viewer);
    const markInstanceSecond = new Mark(viewerSecond);

    // Use Sets to automatically handle duplicates
    const noMatchOriginal = new Set<{ text: string, sectionKey: string }>();
    const noMatchAI = new Set<{ text: string, sectionKey: string }>();
    const markingPromises: Promise<void>[] = [];

    // Create a shared click handler for both original and AI sections
    const createClickHandler = (sectionKey: string, element: HTMLElement) => {
      return (evt: MouseEvent) => {
        evt.preventDefault();
        evt.stopPropagation();

        // Store a reference to the clicked element
        const clickedElement = element;

        // Remove previous active highlights if this is a different section
        if (this.activeSection && this.activeSection !== sectionKey) {
          this.updateSectionNumberStyle(this.activeSection, false);
        }

        // Don't toggle off active state when clicking the same section
        // Just maintain the current active state
        if (this.activeSection === sectionKey) {
          // If we're in Project Synapse mode, still open the info panel
          if (this.isProjectSynapseActive) {
            this.openSectionsInformationPanel(sectionKey, clickedElement);
          }
          // But don't deactivate the section
          return;
        }

        // If we're in Project Synapse mode, we need different behavior
        if (this.isProjectSynapseActive) {
          // Open the section information panel
          this.openSectionsInformationPanel(sectionKey, clickedElement);

          // Only scroll to section when in two-column view - otherwise preserve scroll position
          if (this.twoColumns) {
            this.syncScrollToSection(sectionKey);
          } else {
            // Still update active section but don't change scroll in single column view
            this.activeSection = sectionKey;
            this.updateSectionNumberStyle(sectionKey, true);
          }
        } else {
          // Standard behavior for non-Project Synapse mode
          this.scrollToSection(sectionKey, clickedElement);
        }
      };
    };

    // Function to get the correct background color based on section key and state
    const getSectionBackgroundColor = (sectionKey: string): string => {
      const sectionData = this.projectSynapseComparison[sectionKey];
      const isExcluded = sectionData?.isExcluded;
      const isActive = this.activeSection === sectionKey;

      if (isExcluded) {
        return isActive ? this.EXCLUDED_DARK_GREY : this.EXCLUDED_GREY;
      } else {
        return isActive ? this.DARK_PURPLE : this.LIGHT_PURPLE;
      }
    };

    // Modified markSentence function to use shared click handler
    const markSentence = (
      markInstance: any,
      sentence: string,
      sectionKey: string,
      noMatchSet: Set<{ text: string, sectionKey: string }>,
      sectionNumber: number,
      isAIGenerated: boolean
    ): Promise<void> => {
      return new Promise<void>((resolve) => {
        markInstance.mark(sentence.trim(), {
          acrossElements: true,
          separateWordSearch: false,
          limit: 1,
          exclude: ['.canvasWrapper', '[data-markjs="true"]'],
          each: (element: any) => {
            element.style.color = 'transparent';
            element.style.position = 'relative';
            element.style.cursor = 'pointer';
            // Use the helper function to determine the background color
            element.style.background = getSectionBackgroundColor(sectionKey);
            element.style.zIndex = '1';
            element.setAttribute('data-section-id', sectionKey);
            // Also mark whether this is in the original or AI section
            element.setAttribute('data-section-viewer', isAIGenerated ? 'ai' : 'original');

            // Add section number only if this is the first occurrence in this viewer
            const sectionIdentifier = `${sectionKey}-${isAIGenerated ? 'ai' : 'original'}`;
            if (!this.numberedSections.has(sectionIdentifier)) {
              this.numberedSections.add(sectionIdentifier);

              // Find all existing elements with this section ID in the current viewer
              const currentViewer = isAIGenerated ? '#viewerSecond' : '#viewer';
              const existingElements = Array.from(document.querySelectorAll(`${currentViewer} [data-section-id="${sectionKey}"]`));
              let firstElement = existingElements[0]; // Get the first element in the current viewer

              // Only add number to the first element in the current viewer
              if (firstElement === element) {
                // Create a wrapper div for the number to avoid affecting the highlight
                const numberWrapper = document.createElement('div');
                numberWrapper.style.position = 'relative';
                numberWrapper.style.display = 'inline-block';
                numberWrapper.style.width = '0';
                numberWrapper.style.height = '0';
                numberWrapper.style.zIndex = '10';
                element.parentElement.insertBefore(numberWrapper, element);

                // Create and style the section number element
                const numberElement = document.createElement('span');
                numberElement.classList.add('section-number');
                numberElement.textContent = sectionNumber.toString();
                numberElement.style.position = 'absolute';
                numberElement.style.left = '-30px';
                numberElement.style.background = '#EDEDED';
                numberElement.style.padding = '5px 7px';
                numberElement.style.borderRadius = '4px';
                numberElement.style.border = '1px solid #462D86';
                numberElement.style.color = '#462D86';
                numberElement.style.fontSize = '12px';
                numberElement.style.fontWeight = '500';
                numberElement.style.zIndex = '100';
                numberElement.style.top = '-15px';
                numberElement.style.cursor = 'pointer';

                // Add the number element to the wrapper
                numberWrapper.appendChild(numberElement);
              }
            }

            // Use shared click handler or synchronized click handler based on view mode
            if (this.twoColumns) {
              // Bind the method to preserve 'this' context
              element.addEventListener('click', (e) => this.createSynchronizedClickHandler(sectionKey, element)(e));
            } else {
              element.addEventListener('click', createClickHandler(sectionKey, element));
            }
          },
          noMatch: (term: string) => noMatchSet.add({ text: term, sectionKey }),
          done: () => resolve()
        });
      });
    };

    // Helper function for handling noMatch highlighting when provided
    const markNoMatch = (
      markInstance: any,
      text: string,
      sectionKey: string,
      sectionNumber: number,
      isAIGenerated: boolean
    ) => {
      markInstance.mark(text, {
        acrossElements: true,
        separateWordSearch: false,
        limit: 1,
        exclude: ['.canvasWrapper', '[data-markjs="true"]'],
        each: (element: any) => {
          element.style.color = 'transparent';
          element.style.position = 'relative';
          element.style.cursor = 'pointer';
          // Use the helper function to determine the background color
          element.style.background = getSectionBackgroundColor(sectionKey);
          element.style.zIndex = '1';
          element.setAttribute('data-section-id', sectionKey);
          element.setAttribute('data-section-viewer', isAIGenerated ? 'ai' : 'original');

          // Add section number only if this is the first occurrence in this viewer
          const sectionIdentifier = `${sectionKey}-${isAIGenerated ? 'ai' : 'original'}`;
          if (!this.numberedSections.has(sectionIdentifier)) {
            this.numberedSections.add(sectionIdentifier);

            // Find all existing elements with this section ID in the current viewer
            const currentViewer = isAIGenerated ? '#viewerSecond' : '#viewer';
            const existingElements = Array.from(document.querySelectorAll(`${currentViewer} [data-section-id="${sectionKey}"]`));
            let firstElement = existingElements[0]; // Get the first element in the current viewer

            // Only add number to the first element in the current viewer
            if (firstElement === element) {
              // Create a wrapper div for the number to avoid affecting the highlight
              const numberWrapper = document.createElement('div');
              numberWrapper.style.position = 'relative';
              numberWrapper.style.display = 'inline-block';
              numberWrapper.style.width = '0';
              numberWrapper.style.height = '0';
              numberWrapper.style.zIndex = '10';
              element.parentElement.insertBefore(numberWrapper, element);

              // Create and style the section number element
              const numberElement = document.createElement('span');
              numberElement.classList.add('section-number');
              numberElement.textContent = sectionNumber.toString();
              numberElement.style.position = 'absolute';
              numberElement.style.left = '-30px';
              numberElement.style.background = '#EDEDED';
              numberElement.style.padding = '5px 7px';
              numberElement.style.borderRadius = '4px';
              numberElement.style.border = '1px solid #462D86';
              numberElement.style.color = '#462D86';
              numberElement.style.fontSize = '12px';
              numberElement.style.fontWeight = '500';
              numberElement.style.zIndex = '100';
              numberElement.style.top = '-15px';
              numberElement.style.cursor = 'pointer';

              // Add the number element to the wrapper
              numberWrapper.appendChild(numberElement);
            }
          }

          // Use shared click handler or synchronized click handler based on view mode
          if (this.twoColumns) {
            // Bind the method to preserve 'this' context
            element.addEventListener('click', (e) => this.createSynchronizedClickHandler(sectionKey, element)(e));
          } else {
            element.addEventListener('click', createClickHandler(sectionKey, element));
          }
        }
      });
    };

    if (!noMatch) {
      this.sortedSynapseEntries.forEach(
        ([sectionKey, sectionData]: [string, any], index: number) => {
          const normalizedOriginal = this.normalizeText(sectionData.original);
          const normalizedAIGenerated = this.normalizeText(sectionData.ai_generated);

          // Process original text sentences with section number
          normalizedOriginal.forEach((sentence: string) => {
            if (!sentence.trim()) return;
            markingPromises.push(markSentence(this.markInstance, sentence, sectionKey, noMatchOriginal, index + 1, false));
          });

          // Process AI-generated text sentences with section number
          normalizedAIGenerated.forEach((sentence: string) => {
            if (!sentence.trim()) return;
            markingPromises.push(markSentence(markInstanceSecond, sentence, sectionKey, noMatchAI, index + 1, true));
          });
        }
      );

      // Wait for all highlighting promises to complete
      Promise.all(markingPromises).then(() => {
        const originalArray = Array.from(noMatchOriginal);
        const aiArray = Array.from(noMatchAI);

        if (originalArray.length > 0) {
          this.getTextFromPagesOriginal(originalArray);
        }
        if (aiArray.length > 0) {
          this.getTextFromPagesAI(aiArray);
        }
      });
    } else if (noMatch.sectionKey) {
      // Get the section number from the stored sorted entries
      const sectionIndex = this.sortedSynapseEntries.findIndex(([key]) => key === noMatch.sectionKey);
      const sectionNumber = sectionIndex + 1;

      // If noMatch has sectionKey, use it with section numbering
      markNoMatch(this.markInstance, noMatch.text, noMatch.sectionKey, sectionNumber, false);
      markNoMatch(markInstanceSecond, noMatch.text, noMatch.sectionKey, sectionNumber, true);
    }

    // If there's an active section, make sure it stays highlighted
    if (this.activeSection) {
      setTimeout(() => {
        this.applyActiveSection(this.activeSection);
      }, 200);
    }
  }

  private findHighlightText(sentence: string, term: string): string | null {
    let successCounter = 0;
    let startIndex = 0;
    let keepChecking = false;

    for (let i = 0; i < sentence.length; i++) {
      // Skip spaces (the original check was: if the character is not a space)
      if (sentence[i] !== ' ') {
        if (term[successCounter] === sentence[i]) {
          if (!keepChecking) {
            startIndex = i;
            keepChecking = true;
          }
          successCounter++;
          if (successCounter === term.length) {
            // Return the substring from the starting index to the current index (inclusive)
            return sentence.substring(startIndex, i + 1);
          }
        } else {
          // If a partial match was underway, back up one character then reset counters.
          if (successCounter > 0) {
            i--;
          }
          successCounter = 0;
          keepChecking = false;
        }
      }
    }
    return null;
  }

  private processTextForHighlight(viewerSelector: string, noMatchTerms: any): void {
    const textForHighlight: string[] = [];
    const pageText = $(`${viewerSelector} [data-loaded="true"]`).text();

    const matchResult = pageText.match(
      /((?:[A-Z][a-z]\.|\w\.\w.|.)*?(?:[.!?]|$))(?:\s+|$)/g
    );
    const sentences = matchResult ? matchResult.map(s => s.trim()) : [];

    if (sentences.length > 0) {
      sentences.pop();
    }

    for (const term of noMatchTerms) {
      const cleanedTerm = term.text.replace(/\s+/g, '');
      for (const sentence of sentences) {
        const textToHighlight = this.findHighlightText(sentence, cleanedTerm);
        if (textToHighlight) {
          // Pass both the text and sectionKey
          this.doAIHighlight(this.page, { text: textToHighlight, sectionKey: term.sectionKey });
        }
      }
    }
  }

  getTextFromPagesOriginal(noMatchOriginal: any) {
    this.processTextForHighlight('#viewer', noMatchOriginal);
  }

  getTextFromPagesAI(noMatchAI: any) {
    this.processTextForHighlight('#viewerSecond', noMatchAI);
  }

  // Add this helper method to the class
  private scrollToSection(sectionKey: string, element: HTMLElement) {
    if (!element) return;

    // Get the page for the element
    const page = this.getPageForElement(element);
    if (!page) return;

    // Set as active section (if not already active)
    if (this.activeSection !== sectionKey) {
      // Clear previous active section
      if (this.activeSection) {
        this.updateSectionNumberStyle(this.activeSection, false);
      }

      // Set new active section
      this.activeSection = sectionKey;
      this.updateSectionNumberStyle(sectionKey, true);
    }

    // Open information panel for the section
    this.openSectionsInformationPanel(sectionKey, element);

    // Check if we need to change pages
    if (page !== this.page) {
      // Change to the page where the section is located
      this.page = page;
      this.callHighlight(page);

      // After page change, scroll to the element
      setTimeout(() => {
        // Find the element again after page change
        const updatedElement = document.querySelector(`[data-section-id="${sectionKey}"]`) as HTMLElement;
        if (updatedElement) {
          updatedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 300);
    } else {
      // Already on correct page, just scroll to element
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // Add this helper function to handle section number styling
  private updateSectionNumberStyle(sectionKey: string, isActive: boolean) {
    // First update the number element style
    const numberElements = document.querySelectorAll(`.section-number`);
    numberElements.forEach((numberElement: any) => {
      if (numberElement.textContent && this.sortedSynapseEntries) {
        const sectionNumber = parseInt(numberElement.textContent);
        if (sectionNumber > 0 && sectionNumber <= this.sortedSynapseEntries.length) {
          const [key] = this.sortedSynapseEntries[sectionNumber - 1];
          if (key === sectionKey) {
            if (isActive) {
              numberElement.style.background = '#462D86';
              numberElement.style.color = 'white';
            } else {
              numberElement.style.background = '#EDEDED';
              numberElement.style.color = '#462D86';
            }
          }
        }
      }
    });

    // Update the active section
    if (isActive) {
      this.activeSection = sectionKey;
    } else if (this.activeSection === sectionKey) {
      this.activeSection = null;
    }

    // Update all highlights for the section when its style changes
    this.updateSectionHighlightStyles(sectionKey);
  }

  /**
   * Updates the highlight styles for all elements with the specified section key
   * @param sectionKey The section key to update highlights for
   */
  private updateSectionHighlightStyles(sectionKey: string) {
    // Get the section data to determine if it's excluded
    const sectionData = this.projectSynapseComparison[sectionKey];
    const isExcluded = sectionData?.isExcluded || false;
    const isActive = this.activeSection === sectionKey;

    // Determine the appropriate background colors
    const backgroundColor = isExcluded
      ? (isActive ? this.EXCLUDED_DARK_GREY : this.EXCLUDED_GREY)
      : (isActive ? this.DARK_PURPLE : this.LIGHT_PURPLE);

    // Update all elements with this section key in both viewers
    const highlightedElements = document.querySelectorAll(`[data-section-id="${sectionKey}"]`);
    highlightedElements.forEach((element: any) => {
      element.style.background = backgroundColor;
    });

    // Also update section number styling to visually indicate active state
    if (isActive) {
      const numberElements = document.querySelectorAll(`.section-number`);
      numberElements.forEach((numberElement: any) => {
        if (numberElement.textContent && this.sortedSynapseEntries) {
          const sectionNumber = parseInt(numberElement.textContent);
          if (sectionNumber > 0 && sectionNumber <= this.sortedSynapseEntries.length) {
            const [key] = this.sortedSynapseEntries[sectionNumber - 1];
            if (key === sectionKey) {
              numberElement.style.background = '#462D86';
              numberElement.style.color = 'white';
            }
          }
        }
      });
    }
  }

  // Add this new method to determine the secondPdfSrc
  private setSecondPdfUrl() {
    console.log('Setting second PDF URL from projectSynapseData:', this.projectSynapseData);

    if (this.projectSynapseData && Array.isArray(this.projectSynapseData) && this.projectSynapseData.length > 0) {
      // If we have data from multiple models, find the current model or use the first one
      console.log(this.projectSynapseComparison, 'projectSynapseComparison');

      const currentModelName = this.projectSynapseComparison.section_1.model_name;
      let modelData;

      if (currentModelName) {
        // Try to find the model by name
        modelData = this.projectSynapseData.find(model => model.modelName === currentModelName);
      }

      // If we couldn't find by name or no name was specified, use the first model
      if (!modelData && this.projectSynapseData.length > 0) {
        modelData = this.projectSynapseData[0];
      }

      if (modelData && modelData.pdfUrl) {
        console.log('Found PDF URL for model:', modelData.modelName);
        this.secondPdfSrc = modelData.pdfUrl;
      } else {
        console.error('No PDF URL found in projectSynapseData');
        // Consider setting a default or placeholder PDF if needed
      }
    } else {
      console.error('Invalid projectSynapseData format or empty data');
    }
  }

  // Modify the existing createClickHandler or doAIHighlight method
  private createSynchronizedClickHandler(sectionKey: string, element: HTMLElement) {
    return (evt: MouseEvent) => {
      evt.preventDefault();
      evt.stopPropagation();

      // Store a reference to the clicked element
      const clickedElement = element;

      // Remove previous active highlights if this is a different section
      if (this.activeSection && this.activeSection !== sectionKey) {
        this.updateSectionNumberStyle(this.activeSection, false);
      }

      // Don't toggle off active state when clicking the same section
      // Just open the information panel again and maintain the active state
      if (this.activeSection === sectionKey) {
        this.openSectionsInformationPanel(sectionKey, clickedElement);
        return;
      }

      // Set current section as active
      this.activeSection = sectionKey;
      this.updateSectionNumberStyle(sectionKey, true);

      // Open information panel for the section
      this.openSectionsInformationPanel(sectionKey, clickedElement);

      // Synchronize scrolling between the two views
      this.syncScrollToSection(sectionKey);
    };
  }
  // New method to synchronize scrolling to the same section in both PDFs
  private syncScrollToSection(sectionKey: string) {
    // Mark that we're in a synchronized scrolling operation
    this.isScrollingSynced = true;

    try {
      // Find the original section element
      const originalElement = document.querySelector(`.original-pdf-container [data-section-id="${sectionKey}"]`) as HTMLElement;
      const aiElement = document.querySelector(`.ai-pdf-container [data-section-id="${sectionKey}"]`) as HTMLElement;

      if (!originalElement || !aiElement) {
        console.warn(`Cannot find elements for section ${sectionKey}`);
        this.isScrollingSynced = false;
        return;
      }

      // Get the containers to scroll
      const originalContainer = document.querySelector('.original-pdf-container') as HTMLElement;
      const aiContainer = document.querySelector('.ai-pdf-container') as HTMLElement;

      if (!originalContainer || !aiContainer) {
        console.warn('Cannot find PDF containers');
        this.isScrollingSynced = false;
        return;
      }

      // Get original scroll positions before any changes
      const originalScrollTop = originalContainer.scrollTop;
      const aiScrollTop = aiContainer.scrollTop;

      // Get the page for the original element
      const originalPage = this.getPageForElement(originalElement);
      const aiPage = this.getPageForElement(aiElement);

      // Update page if needed
      let pageChanged = false;
      if (originalPage !== this.page) {
        pageChanged = true;
        this.page = originalPage;
      }

      // Calculate the position relative to the viewport for both elements
      const originalRect = originalElement.getBoundingClientRect();
      const aiRect = aiElement.getBoundingClientRect();

      // Calculate optimal position (1/3 down from the top of the container)
      const optimalPosition = originalContainer.clientHeight * 0.33;

      // Calculate the scroll positions needed to put elements at the optimal position
      const originalTargetScroll = originalElement.offsetTop - optimalPosition;
      const aiTargetScroll = aiElement.offsetTop - optimalPosition;

      // If page changed, wait for rendering to complete before scrolling
      if (pageChanged) {
        // Apply highlighting for the current page
        this.callHighlight(this.page);

        // Wait for rendering to complete
        setTimeout(() => {
          // Refresh elements after page change
          const updatedOriginalElement = document.querySelector(`.original-pdf-container [data-section-id="${sectionKey}"]`) as HTMLElement;
          const updatedAiElement = document.querySelector(`.ai-pdf-container [data-section-id="${sectionKey}"]`) as HTMLElement;

          if (updatedOriginalElement && updatedAiElement) {
            // Recalculate target scroll after page change
            const newOriginalTargetScroll = updatedOriginalElement.offsetTop - optimalPosition;
            const newAiTargetScroll = updatedAiElement.offsetTop - optimalPosition;

            // Smooth scroll both containers to their targets
            originalContainer.scrollTo({
              top: newOriginalTargetScroll,
              behavior: 'smooth'
            });

            aiContainer.scrollTo({
              top: newAiTargetScroll,
              behavior: 'smooth'
            });
          } else {
            // If updated elements not found, restore original scroll positions
            originalContainer.scrollTop = originalScrollTop;
            aiContainer.scrollTop = aiScrollTop;
          }

          this.isScrollingSynced = false;
        }, 150);
      } else {
        // If on the same page, just scroll directly
        originalContainer.scrollTo({
          top: originalTargetScroll,
          behavior: 'smooth'
        });

        aiContainer.scrollTo({
          top: aiTargetScroll,
          behavior: 'smooth'
        });

        setTimeout(() => {
          this.isScrollingSynced = false;
        }, 500);
      }
    } catch (error) {
      console.error('Error in syncScrollToSection:', error);
      this.isScrollingSynced = false;
    }
  }

  // Helper method to determine what page an element is on
  private getPageForElement(element: HTMLElement): number {
    // Find the closest parent with a page number
    let current = element;
    while (current && current.parentElement) {
      if (current.hasAttribute('data-page-number')) {
        const pageNum = parseInt(current.getAttribute('data-page-number') || '0', 10);
        return pageNum;
      }
      current = current.parentElement;
    }
    return 0;
  }

  // Add this method to the document component
  closeSideBySideView() {
    this.twoColumns = false;
    this.reportService.isSideBySideVisibleSubject.next(false);

    // Reset zoom and transformations
    this.zoom = 1;

    // Force update the UI
    this.cdr.detectChanges();

    // Properly clean up all styles and reset the viewer
    this.resetViewerSizes();

    // Remove any injected CSS
    const existingStyle = document.getElementById('pdf-viewer-fix');
    if (existingStyle) {
      existingStyle.remove();
    }

    // Update viewer size after a short delay
    setTimeout(() => {
      this.updateViewerSize();
      // Force browser to recalculate layout
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }

  // Add a new method to reset viewer sizes
  private resetViewerSizes() {
    // Get the main PDF viewer
    const viewer = document.getElementById('viewer');
    if (viewer) {
      // Reset the PDF viewer element attributes
      this.setViewerParameters();

      // Force specific styling for key elements
      viewer.querySelectorAll('.page').forEach(page => {
        const pageEl = page as HTMLElement;
        pageEl.style.width = 'auto';
        pageEl.style.maxWidth = '100%';
        pageEl.style.margin = '0 auto';
        pageEl.style.transform = 'none';
        pageEl.style.transformOrigin = 'center top';
        pageEl.style.position = 'relative';
        pageEl.style.display = 'block';
      });

      // Set the viewer container to full width
      viewer.querySelectorAll('.pdf-viewer-container').forEach(container => {
        const containerEl = container as HTMLElement;
        containerEl.classList.remove('half-width');
        containerEl.style.width = '100%';
        containerEl.style.maxWidth = 'none';
        containerEl.style.overflowX = 'hidden';
      });

      // Reset the PDF container sizing
      viewer.querySelectorAll('.ng2-pdf-viewer-container').forEach(container => {
        const containerEl = container as HTMLElement;
        containerEl.style.width = '100%';
        containerEl.style.maxWidth = 'none';
        containerEl.style.overflowX = 'hidden';
      });

      // Force a resize event
      window.dispatchEvent(new Event('resize'));
    }

    // Create a style element with very specific rules that will take precedence
    const style = document.createElement('style');
    style.id = 'pdf-viewer-single-view';
    style.textContent = `
      /* Target the page elements directly with high specificity */
      .document-container:not(.two-columns) .page {
        max-width: 100% !important;
        width: 100% !important;
        margin: 0 auto !important;
        transform: none !important;
      }

      /* Target the canvas elements directly */
      .document-container:not(.two-columns) canvas {
        width: 100% !important;
        max-width: 100% !important;
        display: block !important;
        margin: 0 auto !important;
      }

      /* Ensure the PDF viewer has proper dimensions */
      .document-container:not(.two-columns) pdf-viewer {
        width: 100% !important;
        display: block !important;
      }
    `;

    // Remove any existing styles
    const existingStyle = document.getElementById('pdf-viewer-single-view');
    if (existingStyle) {
      existingStyle.remove();
    }

    // Add the style to the document head
    document.head.appendChild(style);

    // Reset zoom
    this.zoom = 1;

    // Force layout calculation
    setTimeout(() => {
      // Trigger a resize event to force recalculation
      window.dispatchEvent(new Event('resize'));

      // Trigger a second resize after a delay for good measure
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 500);
    }, 100);

    // Add these additional steps to ensure complete reset
    const documentContainer = document.querySelector('.document-container');
    if (documentContainer) {
      documentContainer.classList.remove('two-columns');
    }

    const documentViewer = document.querySelector('.document_viewer');
    if (documentViewer) {
      documentViewer.classList.remove('column-view');
    }

    // Force cleanup of second viewer if it exists
    const secondViewer = document.getElementById('viewerSecond');
    if (secondViewer && secondViewer.parentNode) {
      (secondViewer.parentNode as HTMLElement).classList.add('hidden');
    }

    // Force recalculation of layout after class changes
    setTimeout(() => {
      // Trigger resize event after class changes are applied
      window.dispatchEvent(new Event('resize'));
    }, 50);
  }

  // Modify the method that handles side-by-side visibility changes
  private handleSideBySideVisibilityChange(isVisible: boolean) {
    // Store the current active section
    if (isVisible && this.activeSection) {
      this.lastActiveSection = this.activeSection;
    }

    // Set the view mode
    this.twoColumns = isVisible;

    if (isVisible) {
      // Set the second PDF URL for side-by-side view
      this.setSecondPdfUrl();

      // Update the UI
      this.cdr.detectChanges();

      // Resize the viewers
      this.forceResizePdfViewers();
    } else {
      // Completely reset all viewer parameters and styles for single view
      this.resetViewerSizes();

      // Update the UI
      this.cdr.detectChanges();

      // Force the viewer to recalculate layout
      setTimeout(() => {
        // Set viewer parameters again after a delay
        this.setViewerParameters();

        // Trigger resize events
        window.dispatchEvent(new Event('resize'));
      }, 100);
    }

    // Update sizing and restore active section
    setTimeout(() => {
      this.updateViewerSize();

      // Restore active section if needed
      if (isVisible && this.lastActiveSection) {
        // Use a small delay to ensure viewers are ready
        setTimeout(() => {
          this.applyActiveSection(this.lastActiveSection);
        }, 300);
      }

      // Trigger a single resize event with a delay
      setTimeout(() => {
        this.updateViewerSize();
        window.dispatchEvent(new Event('resize'));
      }, 500);
    }, 300);
  }

  // Add this method to apply active section highlighting to both PDFs
  private applyActiveSection(sectionKey: string) {
    this._applyActiveSectionAttempts++;
    // If we've tried too many times, give up to prevent infinite loops
    if (this._applyActiveSectionAttempts > 5) {
      console.warn('Too many attempts to apply active section, giving up');
      this._applyActiveSectionAttempts = 0;
      return;
    }

    // Find elements with the given section key
    const elements = document.querySelectorAll(`[data-section-id="${sectionKey}"]`);

    if (elements && elements.length > 0) {
      // Success - update the active section
      this.activeSection = sectionKey;
      this.updateSectionNumberStyle(sectionKey, true);
      this._applyActiveSectionAttempts = 0;

      // Also update all section highlights to ensure proper coloring
      this.updateSectionHighlightStyles(sectionKey);
    } else {
      // If elements aren't found (might still be loading), try again after a delay
      setTimeout(() => {
        this.applyActiveSection(sectionKey);
      }, 200);
    }
  }

  // Update the component's PDF viewer configuration
  private setViewerParameters() {
    // Get the main viewer element
    const viewer = document.getElementById('viewer');
    if (viewer) {
      // Get the ng2-pdf-viewer element
      const pdfViewer = viewer.querySelector('pdf-viewer');
      if (pdfViewer) {
        // Set fit-to-page to false
        (pdfViewer as any).fitToPage = false;

        // Force the zoom scale to page-width
        (pdfViewer as any).zoomScale = 'page-width';

        // Set a slightly higher zoom value
        this.zoom = 1.0;
      }
    }
  }

  // Add HostListener to detect route changes or component deactivation
  @HostListener('window:beforeunload')
  @HostListener('window:popstate')
  resetViewOnNavigation() {
    // Ensure we reset to single view when navigating away
    if (this.twoColumns) {
      this.twoColumns = false;
      this.secondPdfSrc = '';
      this.resetViewerSizes();
    }
  }

  /**
   * Opens the section information panel with the selected section data
   * @param sectionKey The key of the section to display
   * @param element The DOM element that was clicked
   */
  private openSectionsInformationPanel(sectionKey: string, element: HTMLElement): void {
    // First highlight the UI elements appropriately
    this.activeSection = sectionKey;
    this.lastActiveSection = sectionKey;

    // Highlight both original and AI sections
    document.querySelectorAll(`[data-section-id="${sectionKey}"]`).forEach((el: any) => {
      const sectionData = this.projectSynapseComparison[sectionKey];
      el.style.background = sectionData?.isExcluded ? this.EXCLUDED_DARK_GREY : this.DARK_PURPLE;
    });

    this.updateSectionNumberStyle(sectionKey, true);

    // Update sentence information with new section data and ensure Project Synapse context
    const sectionData = this.projectSynapseComparison[sectionKey];
    if (sectionData) {
      const dataWithContext = {
        ...sectionData,
        isProjectSynapse: true
      };
      this.reportService.sentenceInformation(dataWithContext, 'ai', null);
    }
  }

}
